import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconDown({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `edu-icon edu-icon--${size} ${className}`;
  return <>{!!srText && <span className='sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" d="M4.41 8.09A.833.833 0 1 1 5.59 6.91l4.41 4.412 4.412-4.411a.833.833 0 1 1 1.178 1.178l-5 5a.833.833 0 0 1-1.178 0z" /></svg></>;
}
export default IconDown;